import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { ItpxValidators } from 'app/shared/validators/itpx-validators';

@Component({
  selector: 'itpx-rate-product',
  templateUrl: './rate-product.component.html',
  styleUrls: ['./rate-product.component.css']
})
export class RateProductComponent implements OnInit {
  @ViewChild('fieldName') inputEl: ElementRef;
  @Input()
  private data: any;

  private reviewForm: FormGroup;
  private review: string;
  private rating: number;
  private range = [1, 2, 3, 4, 5];
  private marked = -1;
  private showMessage = false;
  private charEntered: number;
  constructor(private fb: FormBuilder, private modalService: SmartModalService) { }

  private showMessageSoon() {
    this.showMessage = true
    setTimeout.bind(this)(() => {
      this.showMessage = false;
    }, 500);

  }

  private onYes({ value, valid }: { value: any, valid: boolean }) {
    if (this.rating > 2 || valid)
      this.modalService.sendResult({ review: value.reviewComment, rating: this.rating, anonymize: value.anonymizeCheckbox });
    else {
      this.showMessageSoon();
      this.inputEl.nativeElement.focus();
    }
  }

  private onNo() {
    console.log('sad');
    this.modalService.sendResult(null);
  }

  public mark = (index) => {
    this.marked = this.marked == index ? index - 1 : index;
    this.rating = this.marked + 1;
  }

  public isMarked = (index) => {
    if (index <= this.marked) {
      return 'fa-star';
    }
    else {
      return 'fa-star-o';
    }

  }


  ngOnInit() {
    // console.log(this.range);
    this.reviewForm = this.fb.group({
      reviewComment: [null, [Validators.required, Validators.minLength(1)], this.trimAsyncValidator],
      anonymizeCheckbox: [false, [Validators.required, ItpxValidators.booleanValidator]],
    });
    if (this.data.review.rating) {
      this.mark(this.data.review.rating - 1);
      this.reviewForm.controls['reviewComment'].setValue(this.data.review.reviewText);
      this.reviewForm.controls['anonymizeCheckbox'].setValue(this.data.review.anonymize);
      this.charEntered = this.data.review.reviewText ? this.data.review.reviewText.length : 0;
    }
    else
      this.charEntered = 0;
  }

  trimAsyncValidator(control: AbstractControl): Observable<ValidationErrors> {
    return control.value ? control.value.trim() === "" ? of({ custom: { message: 'please write smth' } }) : of(null) : of(null);
  }
  countChar(e) {
    this.charEntered = e.length;
  };

}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/rate-product/rate-product.component.ts